import { useMutation, useQueryClient } from 'react-query';
import { getQueryTransportKeys } from '../getQueryTransportKeys';
import request from '../../../../helpers/request';

const addAttachemnt = async ({ transportId, file }) => {
  const formData = new FormData();
  formData.append('file', file);

  return request.post(
    `/HousingStock/transport/${transportId}/attachments`,
    formData,
    `При загрузке файла ${file.name} произошла ошибка`,
    'Error'
  );
};

const useAddAttachment = () => {
  const queryClient = useQueryClient();
  return useMutation(addAttachemnt, {
    onSuccess: (data, { transportId }) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(
        getQueryTransportKeys.transportDocs(transportId)
      );
    },
  });
};

export default useAddAttachment;
